import { NBSP } from "../ProductCard/constants";
export var weightGRtoKG = function weightGRtoKG(weight) {
  return weight / 1000;
};
export var weightKGtoGR = function weightKGtoGR(weight) {
  return weight * 1000;
};
export var numberToFloatString = function numberToFloatString(value) {
  return (Math.round(value * 100) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, NBSP).replace('.', ',');
};
export var numberToFormattedCurrencyString = function numberToFormattedCurrencyString(val) {
  var formattedString = numberToFloatString(val);
  var splitted = formattedString.split(',');
  var decimal = splitted[1];

  if (!decimal) {
    return "".concat(formattedString, ",00");
  }

  if (decimal.length === 1) {
    return "".concat(formattedString, "0");
  }

  return formattedString;
};
export var calcQuantity = function calcQuantity(quantity, weight, isWeight) {
  return numberToFloatString(isWeight ? weightGRtoKG(quantity * weight) : quantity);
};
export var localeStrNumberToFloat = function localeStrNumberToFloat(value) {
  return Number(value.replace(',', '.'));
};
export var getLocaleNumberStr = function getLocaleNumberStr(value) {
  var isValueEmpty = value === '';
  var valueShouldNotBeFormated = isValueEmpty || /^,|,$/.test(value);
  return valueShouldNotBeFormated ? value : numberToFormattedCurrencyString(localeStrNumberToFloat(value)).replace(/,0+$/, '');
};
export var getIntegerString = function getIntegerString(value) {
  return value.replace(/\D/g, '');
};